import { gql, useMutation } from '@apollo/client'
import type { BrandInfo } from '@@partner:types:app'
import type { MobileAppConfig } from '@@partner:types:app'

export interface UpdateMobileAppConfigResult {
  updateMobileAppConfig: BrandInfo
}

export interface UpdateMobileAppConfigVariables {
  mobileAppConfig: MobileAppConfig
}

export const GQL_MUTATION_UPDATE_MOBILE_APP_CONFIG = gql`
  mutation($mobileAppConfig: MobileAppConfigInput) {
    updateMobileAppConfig(mobileAppConfig: $mobileAppConfig) {
      id
      assemblerConfig {
        minimalVersion
        inAppMessages { type text }
        alerts { title text restrictAccessToApp }
        positionCancelReasons { text canComment requireComment }
        orderCancelReasons { text canComment requireComment }
      }
    }
  }
`

export const useMutateUpdateMobileAppConfig = () =>
  useMutation<UpdateMobileAppConfigResult, UpdateMobileAppConfigVariables>(
    GQL_MUTATION_UPDATE_MOBILE_APP_CONFIG
  )
